/* eslint-disable jira/import-whitelist */
import queryString from 'query-string';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import type { JiraPlanDataRestResponse } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';
import { fetchUIFBacklogDataOld } from '@atlassian/jira-software-uif-early-script/src/services/fetch-uif-backlog-data/index.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';

const BACKLOG_FETCH_START_MARK = 'UIF_BACKLOG_FETCH_START';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async ({
	query: routerQuery,
	match,
	route: { name: routeName },
}: RouterDataContext): Promise<JiraPlanDataRestResponse | null> => {
	if (
		routeName !== 'rapidboard-backlog' &&
		routeName !== 'rapidboard-user-backlog' &&
		routeName !== 'rapidboard-backlog-embed'
	) {
		return null;
	}

	setMark(BACKLOG_FETCH_START_MARK);

	// As react-resource-router will only return the first query param it finds instead of as possible string[]
	const query =
		typeof window !== 'undefined' ? queryString.parse(window.location.search) : routerQuery;

	try {
		setTimeout(() => {
			setMark(prefetchApiStartMark);
		});
		// Stop query when loading a config page
		if (query.config) {
			return null;
		}
		const { rapidView } = query;
		const boardId = match.params.boardId || rapidView;
		const data = await fetchUIFBacklogDataOld(Number(boardId), query);
		setMark(prefetchApiReadyMark);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.next-gen.backlog.getRestData',
				message: 'An error was thrown while prefetching backlog REST data',
				name: 'ResourceError',
			},
			error,
		);
	}
};
